module.exports = __webpack_public_path__ + "static/media/PDF_Icon.ac2b5265.svg";